const shouldShowRecommendations = (
  query: string,
  hasFiltersSelectedOrApplied: boolean,
) => !query && !hasFiltersSelectedOrApplied;

export default shouldShowRecommendations;
